import { FunctionComponent, useContext } from "react";
import Button from "../../components/Button/Button";
import ModalGlobal from "../../components/UI/Modal/ModalGlobal";
import { Store } from "../../Store";
import { Document, DocumentGroup } from "../../utils/interface";
import classes from './DocumentList.module.css';
import {CloseAllModal} from "../../utils/CloseAllModal";

interface Props {
    group?: DocumentGroup ;
    documents: Document[];
    onClose: () => void;
    confirm: () => void;
}

const DeleteDocumentModal: FunctionComponent<Props> = ({group, documents, onClose, confirm}) => {
    const {selectedPlant, setIsModal} = useContext(Store);
    const close = () => {        
        setIsModal && setIsModal!({ ...CloseAllModal });
    };

    return (
        <ModalGlobal modaltitle={`Delete (${documents.length}) Document(s)?`} isModalHeader={true} modalClose={() => {
            close();
            onClose();
        }}>
            <div className={`${classes.delete_modal_body} ${classes.flex_column}`}>
                <p>Are you sure you want to delete this document from the {group?.name} document group? This document will no longer be accessible to Insurance Community users. This cannot be undone.</p>
                <ul>
                    {documents.map(doc => (
                        <li key={doc.globalItemId}>{doc.displayName}</li>
                    ))}
                </ul>
                <div className={classes.flex_row}>
                    <Button className={`redDelete`} disabled={false} text={"Yes, Delete"} onClick={() => {
                        close();
                        confirm();
                    }} />
                    <Button className={`whiteBtn`} disabled={false} text={"Cancel"} onClick={() => {
                        close();
                        onClose();
                    }} />
                </div>
            </div>
        </ModalGlobal>
    );
}

export default DeleteDocumentModal;